import { makeStyles } from '@material-ui/core';



export const paddingStyles = makeStyles((theme) => ({
    containerPadding: {
        padding: '3rem',
        [theme.breakpoints.down('md')]: {
            padding: '2rem',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '1rem',
        },
        '&.limited-page-width': {
            maxWidth: '100rem',
            margin:'0 auto',
        },
    },
    contentPadding: {
        paddingRight: '3rem',
        [theme.breakpoints.down('md')]: {
            paddingRight: '2rem',
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: '0',
        },

    },
    containerBottomPadding: {
        paddingBottom: theme.spacing(2),
        
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(1.5),
        },
    },


}));



